import { InjectionToken } from '@angular/core';
import { GlobalConfig } from '../interfaces/global-config.model';

export const GLOBAL_CONFIG = new InjectionToken<GlobalConfig>('GLOBAL_CONFIG');
